import axios from '../../utils/AxiosWrapper';
import { wentWrong } from '../../utils/ToastConfig';

export const Type = {
    GET_IMPLEMENT_GROUP_CALL: 'GET_IMPLEMENT_GROUP_CALL',
    GET_IMPLEMENT_GROUP_SUCCESS: 'GET_IMPLEMENT_GROUP_SUCCESS',
    GET_IMPLEMENT_GROUP_FAILED: 'GET_IMPLEMENT_GROUP_FAILED',

    GET_IMPLEMENT_SUBGROUP_CALL: 'GET_IMPLEMENT_SUBGROUP_CALL',
    GET_IMPLEMENT_SUBGROUP_SUCCESS: 'GET_IMPLEMENT_SUBGROUP_SUCCESS',
    GET_IMPLEMENT_SUBGROUP_FAILED: 'GET_IMPLEMENT_SUBGROUP_FAILED',

    ADD_IMPLEMENT_CALL: 'ADD_IMPLEMENT_CALL',
    ADD_IMPLEMENT_SUCCESS: 'ADD_IMPLEMENT_SUCCESS',
    ADD_IMPLEMENT_FAILED: 'ADD_IMPLEMENT_FAILED',

    DELETE_IMPLEMENT_CALL: 'DELETE_IMPLEMENT_CALL',
    DELETE_IMPLEMENT_SUCCESS: 'DELETE_IMPLEMENT_SUCCESS',
    DELETE_IMPLEMENT_FAILED: 'DELETE_IMPLEMENT_FAILED',

    SET_IMPLEMENT_OBJ: 'SET_IMPLEMENT_OBJ',
    SET_INITIAL_STATE: 'SET_IMPLEMENT_INITIAL_STATE'
};

export function getGroup() {
    return (dispatch) => {
        dispatch({ type: Type.GET_IMPLEMENT_GROUP_CALL });

        axios.get('api/implement_group/drop_down')
            .then((response) => {
                dispatch({
                    type: Type.GET_IMPLEMENT_GROUP_SUCCESS,
                    data: response.data && response.data.data ? response.data.data : []
                });
            })
            .catch(() => {
                wentWrong('Something went wrong, please try again!');
                dispatch({ type: Type.GET_IMPLEMENT_GROUP_FAILED });
            });
    };
}

export function getSubgroup(id) {
    return (dispatch) => {
        dispatch({ type: Type.GET_IMPLEMENT_SUBGROUP_CALL });

        axios.get(`api/implement_subgroup/drop_down${id ? '?id_grupa=' + id : ''}`)
            .then((response) => {
                dispatch({
                    type: Type.GET_IMPLEMENT_SUBGROUP_SUCCESS,
                    data: response.data && response.data.data ? response.data.data : []
                });
            })
            .catch(() => {
                wentWrong('Something went wrong, please try again!');
                dispatch({ type: Type.GET_IMPLEMENT_SUBGROUP_FAILED });
            });
    };
}

export function addImplement(payload) {
    return (dispatch) => {
        dispatch({ type: Type.ADD_IMPLEMENT_CALL });

        axios.post('api/implement/create', payload)
            .then(() => {
                dispatch({ type: Type.ADD_IMPLEMENT_SUCCESS });
            })
            .catch(() => {
                wentWrong('Something went wrong, please try again!');
                dispatch({ type: Type.ADD_IMPLEMENT_FAILED });
            });
    };
}

export function deleteImplement(selection) {
    return (dispatch) => {
        const ids = Array.isArray(selection) ? selection : [];
        if (!ids.length) {
            return;
        }

        dispatch({ type: Type.DELETE_IMPLEMENT_CALL });

        axios.post('api/implement/delete', { selection: ids })
            .then(() => {
                dispatch({ type: Type.DELETE_IMPLEMENT_SUCCESS });
            })
            .catch(() => {
                wentWrong('Something went wrong, please try again!');
                dispatch({ type: Type.DELETE_IMPLEMENT_FAILED });
            });
    };
}

export function setImplementObj(data) {
    return (dispatch) => {
        dispatch({
            type: Type.SET_IMPLEMENT_OBJ,
            data
        });
    };
}

export function setInitialState(component) {
    return (dispatch) => {
        dispatch({
            type: Type.SET_INITIAL_STATE,
            data: component
        });
    };
}
